module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};



//////////////////
// WEBPACK FOOTER
// /opt/jenkins_home/workspace/marketing-campaigns_deploy_trigger_ce/6341/lib/node_modules/@core/macys-cli/node_modules/core-js/modules/_a-function.js
// module id = 10
// module chunks = 0